<template>
  <div>
    <!-- 상단 고정 캠페인 배너 -->
    <TopAppBar
      :leftBtnMode="leftBtnMode"
      :rightBtnMode="rightBtnMode"
      :title="title"
      :leftBtnMethod="leftBtnMethod"
      :rightBtnMethod="rightBtnMethod"
      staticMode="true"
    ></TopAppBar>

    <NoData v-if="isNoData"></NoData>

    <div class="pdb-34">
      <div id="tab1" class="scroll-y">
        <div
          class="t-color-title t-subtitle2 l-spacing48 pdl-16 pdb-16 pdr-16 pdt-16 font-b"
        >
          {{ $t("452") }}
        </div>
        <div class="pdl-16 pdr-16 pdt-16">
          <div class="d-flex mgb-13">
            <div
              class="placeholderImageDetails overflow-hidden position-relative min-w-100"
            >
              <img
                v-if="itemDetails && itemDetails.thumbnail"
                :src="
                  itemDetails.thumbnail.resourceUri
                    ? itemDetails.thumbnail.resourceUri
                    : 'images/prize_request/dummImage.png'
                "
                class="w-100 h-100"
                alt=""
              />
              <img
                v-else
                src="images/prize_request/dummImage.png"
                class="w-100 h-100"
                alt=""
              />
            </div>
            <div>
              <div
                class="pdl-16 mgb-8 t-subtitle3 l-spacing48 t-color-title font-m"
              >
                {{ itemDetails && itemDetails.name ? itemDetails.name : "" }}
              </div>
              <div
                class="pdl-16 mgb-8 t-body3 l-spacing42 t-color-title font-r"
              >
                {{ $t("1982", { str: qty ? qty : "" }) }}
              </div>
              <div class="d-flex align-items-center">
                <div class="pdl-16 pdr-3 t-body3 t-color-title">
                  <div class="mgr-8">
                    <img
                      src="images/prize_request/p-image.svg"
                      class="w-24 h-24"
                      alt=""
                    />
                  </div>
                </div>
                <div class="t-body1 font-r t-color-title">
                  {{
                    itemDetails && itemDetails.price
                      ? itemDetails.price * qty
                      : ""
                  }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="divider"></div>

        <div
          class="t-color-title t-subtitle2 l-spacing48 pdl-16 pdb-16 pdr-16 pdt-16 font-b"
        >
          {{ $t("454") }}
        </div>
        <!-- <div class="d-flex align-items-baseline">
          <div class="pdl-16 pdr-8 t-body3 t-color-content1 l-spacing42">
            구매자
          </div>
          <div class="t-body1 t-color-title font-r l-spacing48 font-r">
            홍길동
          </div>
        </div> -->

        <div class="myInfoForm">
          <form action="">
            <div class="pdl-16 pdr-16 pdb-8">
              <div
                class="mdc-text-field mdc-text-field--outlined mdc-text-field--with-trailing-icon w-full mgt-7"
                id="name_ref"
              >
                <input
                  type="text"
                  class="mdc-text-field__input"
                  v-model="params.name"
                  @blur="enableButton"
                />

                <div class="mdc-notched-outline">
                  <div class="mdc-notched-outline__leading"></div>
                  <div class="mdc-notched-outline__notch">
                    <label for="tf-outlined" class="mdc-floating-label">
                      {{ $t("S20005") }}
                    </label>
                  </div>
                  <div class="mdc-notched-outline__trailing"></div>
                </div>
              </div>
            </div>

            <!-- Email -->
            <div class="pdl-16 pdr-16 pdb-8">
              <div
                class="mdc-text-field mdc-text-field--outlined mdc-text-field--with-trailing-icon w-full mgt-7"
                id="email_ref"
              >
                <input
                  type="text"
                  class="mdc-text-field__input"
                  v-model="params.email"
                  @blur="enableButton"
                />

                <div class="mdc-notched-outline">
                  <div class="mdc-notched-outline__leading"></div>
                  <div class="mdc-notched-outline__notch">
                    <label for="tf-outlined" class="mdc-floating-label">
                      {{ $t("457") }}
                    </label>
                  </div>
                  <div class="mdc-notched-outline__trailing"></div>
                </div>
              </div>
              <div class="t-helper t-color-blue2 mgl-7 mgr-7 pdt-2 min-h-23">
                <span>
                  {{ $t("458") }}
                  <!-- * 비밀번호를 입력하세요. -->
                </span>
              </div>
            </div>

            <div class="t-body3 t-color-title mgl-16 pdt-16">
              <span>
                {{ $t("S20008") }}
                <!-- * 비밀번호를 입력하세요. -->
              </span>
            </div>
            <div class="pdl-16 pdr-16 pdb-8">
              <div class="mdc-form-field custom_check">
                <div class="mdc-checkbox">
                  <input
                    type="checkbox"
                    class="mdc-checkbox__native-control"
                    id="checkbox-1"
                    v-model="checkBox"
                    @click="handleCheckAll(!checkBox)"
                  />
                  <div class="mdc-checkbox__background">
                    <svg class="mdc-checkbox__checkmark" viewBox="0 0 24 24">
                      <path
                        class="mdc-checkbox__checkmark-path"
                        fill="none"
                        d="M1.73,12.91 8.1,19.28 22.79,4.59"
                      />
                    </svg>
                    <div class="mdc-checkbox__mixedmark"></div>
                  </div>
                  <div class="mdc-checkbox__ripple"></div>
                </div>
                <label class="pdl-1" for="checkbox-1"
                  >{{ $t("S20009") }}
                </label>
              </div>
            </div>

            <div
              class="pdl-16 pdr-16 pdt-17 pdb-16"
              v-if="validate_all == true && checkBox == true"
            >
              <a
                @click.prevent="submitForm"
                class="d-block btn-red t-center pdt-11 pdb-10 t-color-white b-radius4 b-shadow2 t-body2"
                >{{ $t("485") }}</a
              >
            </div>
            <div class="pdl-16 pdr-16 pdt-17 pdb-16" v-else>
              <a
                class="d-block btn-disable t-center pdt-11 pdb-10 t-color-white b-radius4 b-shadow2 t-body2"
                >{{ $t("485") }}</a
              >
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * 나의 학습 목록 메인 컴포넌트(my learning main list component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define

import TopAppBar from "@/components/TopAppBar.vue";
import { topAppBarMixin } from "@/mixins/topAppBar.js";
import { MDCTextField } from "@material/textfield";
import { MDCRipple } from "@material/ripple";
import prizeRequestApi from "@/api/prizeRequestApi.js";
import memberApi from "@/api/memberApi.js";
import ListItem from "./ListItem.vue";
import NoData from "../common/NoData.vue";

export default {
  components: {
    ListItem,
    NoData,
    TopAppBar,
  },

  data() {
    return {
      status: "",
      isNoData: false,
      infiniteId: +new Date(),
      leftBtnMethod: () => {
        this.$router.go(-1);
      },
      showModalCss: false,
      checkBox: true,
      params: {
        name: null,
        email: null,
        quantity: null,
        totalPrice: null,
      },
      itemDetails: null,
      prize_id: null,
      qty: null,
      validate_all: false,
      memberInfo: null,
    };
  },

  computed: {},

  watch: {
    $route(to, from) {
      this.initData();
    },
  },

  mixins: [topAppBarMixin],

  mounted() {
    this.prize_id = this.$route.params.prizeid;
    this.qty = this.$route.params.qty;
    this.fetchData();
    this.setTopAppBarBack(this.$t("451"));
    this.getUserInfo();
    this.setMaterialUi();
  },

  methods: {
    getUserInfo() {
      memberApi
        .getMemberInfo()
        .then((response) => {
          this.memberInfo = response.data.data;

          this.name_ref.value = JSON.stringify(
            this.memberInfo.name.fullName
          ).replace(/^"(.*)"$/, "$1");

          this.params.name = JSON.stringify(
            this.memberInfo.name.fullName
          ).replace(/^"(.*)"$/, "$1");
          this.phone_ref.value =
            this.memberInfo.phone !== null
              ? JSON.stringify(this.memberInfo.phone).replace(/^"(.*)"$/, "$1")
              : "";
          this.params.cellphone =
            this.memberInfo.phone !== null
              ? JSON.stringify(this.memberInfo.phone).replace(/^"(.*)"$/, "$1")
              : "";

          this.email_ref.value = JSON.stringify(this.memberInfo.userId).replace(
            /^"(.*)"$/,
            "$1"
          );
          this.params.email = JSON.stringify(this.memberInfo.userId).replace(
            /^"(.*)"$/,
            "$1"
          );
        })
        .catch((err) => {});
    },

    setMaterialUi() {
      this.email_ref = new MDCTextField(document.querySelector("#email_ref"));
      this.name_ref = new MDCTextField(document.querySelector("#name_ref"));
      // this.name_ref.val
      this.passport_ref = new MDCTextField(
        document.querySelector("#passport_ref")
      );

      this.phone_ref = new MDCTextField(document.querySelector("#phone_ref"));

      this.address_ref = new MDCTextField(
        document.querySelector("#address_ref")
      );
    },

    // 목록 데이터 로딩(get list data)
    fetchData() {
      let responseData = null;
      prizeRequestApi
        .prizeProductDetails(this.prize_id)
        .then((response) => {
          this.itemDetails = response.data.data;
        })
        .catch((err) => {});
    },
    submitForm() {
      this.params.quantity = this.qty;
      this.params.totalPrice = this.itemDetails.price;
      console.log("final data", this.params);
      prizeRequestApi
        .prizePurchaseRequest(this.prize_id, this.params)
        .then((response) => {
          // console.log("responseresponse", response.data.data.id);
          this.$router.push({
            name: "PurchaseCompleted",
            params: { prizeid: response.data.data.id },
          });
        })
        .catch((err) => {
          console.log("PURCHASE ERROR : ", err);
        });
    },
    enableButton() {
      this.validate_all = this.params.name !== null &&
          this.params.name !== "" &&
          this.params.email !== null &&
          this.params.email !== "" &&
          this.checkBox === true;
    },
    // check all
    handleCheckAll(checked) {
      this.checkBox = checked;
    },
  },
};
</script>

<style scoped>
.tabs .tab a:focus,
.tabs .tab a:focus.active {
  background-color: #f5f5f5;
  outline: none;
}
.tabs .indicator {
  background: #2d6dcc;
}
.mdc-elevation--z3 {
  border-radius: 4px;
  overflow: hidden;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.26);
  background-color: #ffffff;
}

.tabs .tab {
  width: 50%;
}
.mgb-100 {
  margin-bottom: 100px !important;
}
.footer-tag {
  box-shadow: 1px -4px 12px 0 rgba(0, 0, 0, 0.2);
  bottom: 0;
  z-index: 9999;
}
.bg-blue1 {
  background: #2d6dcc !important;
}

.placeholderImageDetails img {
  object-fit: cover;
  object-position: left;
}
.myInfoForm .select-wrapper input.select-dropdown {
  border: solid 1px rgba(172, 180, 190, 0.7);
  padding-left: 14px;
  box-sizing: border-box;
  border-radius: 4px;
  color: #a6a6a6;
  font-size: 14px;
}
.myInfoForm .select-wrapper .caret {
  right: 12px;
  fill: #a6a6a6;
}
.dropdown-content li > a,
.dropdown-content li > span {
  font-size: 14px;
  color: #818181;
  display: block;
  line-height: 22px;
  padding: 14px 16px;
}
.myInfoForm .customInput {
  border: solid 1px rgba(172, 180, 190, 0.7) !important;
  padding-left: 16px !important;
  box-sizing: border-box !important;
  border-radius: 4px !important;
  color: #212121 !important;
  box-shadow: none !important;
  font-size: 14px !important;
}
.myInfoForm .customInput:focus {
  border-color: #546e7a !important;
}
.myInfoForm .customInput:not([value=""]):not(:focus):invalid {
  border: #546e7a !important;
}
.myInfoForm .input-field > label:not(.label-icon).active {
  -webkit-transform: translateY(-14px) scale(0.8);
  transform: translateY(-14px) scale(0.8);
  -webkit-transform-origin: 0 0;
  transform-origin: left;
  background: #fff;
  padding: 0 10px;
  width: auto !important;
  left: 6px;
  top: 2px;
  color: #546e7a !important;
}
.myInfoForm .input-field > label {
  font-size: 14px !important;
}

.custom_check .mdc-checkbox__background {
  left: 0 !important;
}
.custom_check > label {
  margin-left: -4px;
}
.btn-disable {
  background-color: #dbdbdb;
  color: #9a9a9a;
}
</style>